import BanzaiFilesystemService from '@/services/banzai-filesystem.service'
import {AxiosInstance} from 'axios'
import _Vue from 'vue'

export default {
  install (
    Vue: typeof _Vue,
    { http }: { http: AxiosInstance }) {
    Vue.prototype.$banzaiFileSystem = new BanzaiFilesystemService(http)
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $banzaiFileSystem: BanzaiFilesystemService;
  }
}
